<template>
  <el-form size="small" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="80px">
    <el-form-item label="原密码" prop="old_password">
      <el-input
        type="password"
        placeholder="请输入原密码"
        v-model.trim="ruleForm.old_password"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item label="新密码" prop="new_password">
      <el-input
        type="password"
        placeholder="请输入新密码"
        v-model.trim="ruleForm.new_password"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="checkPass">
      <el-input
        type="password"
        placeholder="请确认新密码"
        v-model.trim="ruleForm.checkPass"
        autocomplete="off"
      ></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import { Form, FormItem, Input } from 'element-ui';
import pattern from '@/utils/pattern';

export default {
  name: 'ChangePwd',
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.ruleForm.new_password) {
        callback(new Error('两次输入的新密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        new_password: '',
        checkPass: '',
        old_password: ''
      },
      rules: {
        old_password: [{ required: true, trigger: 'blur', message: '请输入原密码' }],
        new_password: [
          { required: true, validator: validatePass, trigger: 'blur' },
          {
            required: true,
            trigger: 'blur',
            pattern: pattern.pwd,
            message: '密码必须是6-20位数字字母下划线'
          }
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' },
          {
            required: true,
            trigger: 'blur',
            pattern: pattern.pwd,
            message: '密码必须是6-20位数字字母下划线'
          }
        ]
      }
    };
  },
  methods: {
    submitForm() {
      return new Promise(resolve => {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            resolve({ data: this.ruleForm, valid });
          } else {
            resolve({ data: null, valid });
          }
          return valid;
        });
      });
    }
  }
};
</script>
